import * as React from "react";
import { EditComponent, EditProps as SharedEditProps, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import { Form } from "semantic-ui-react";
import { validators } from "not-valid";

import { connect } from "react-redux";

import { ThunkDispatch } from "redux-thunk";

import { saveTeam } from "../actions";
import { AdminUserDetailModel, loadAdminUsers } from "../../crud/adminUser";
import { Customer, loadCustomers } from "../../crud/customer";
import { getUserDisplayName, getUserSortableName } from "../../crud/adminUser/model";
import { teamSelector, basePathSelector } from "../selectors";
import { TeamEditModel, AppState, Team, getUserDisplayNameAndTeam } from "../model";

import { EditModal } from "./EditModal";

import { push } from "redux-little-router";

export interface EditProps extends SharedEditProps<TeamEditModel> {
    open: boolean;
    adminUsers: AdminUserDetailModel[];
    customers: Customer[];
    usersInOtherTeams: string[];
    teams: Team[];
}

export interface DispatchProps extends SaveDispatchProps<TeamEditModel> {
    close: () => void;
    loadAdminUsersOptions: () => void;
    loadCustomersOptions: () => void;
}

export class Edit extends EditComponent<TeamEditModel, EditProps> {
    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Input.Text
                    value={this.state.values.name}
                    label="Name *"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("name", value, valid)}
                />
                <Input.Email
                    value={this.state.values.email}
                    label="Email *"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("email", value, valid)}
                />
                <Input.PhoneNumber
                    value={this.state.values.phoneNumber}
                    label="Phone Number *"
                    showErrors={this.state.showErrors}
                    required
                    validation={[validators.validPhoneNumber(10)]}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("phoneNumber", value, valid)}
                />
                <Input.DropdownMulti
                    dynamicOptions
                    value={this.state.values.customerIds}
                    label="Customers"
                    showErrors={this.state.showErrors}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("customerIds", value, valid)}
                    options={this.props.customers.map(customer => ({ key: customer.id, value: customer.id, text: customer.name }))}
                    search
                />
                <Input.DropdownMulti
                    dynamicOptions
                    value={this.state.values.leaderIds}
                    label="Team Leaders"
                    showErrors={this.state.showErrors}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("leaderIds", value, valid)}
                    options={this.props.adminUsers.map(adminUser => ({ key: adminUser.id, value: adminUser.id, text: getUserDisplayName(adminUser) }))}
                    required
                    search
                />
                <Input.DropdownMulti
                    dynamicOptions
                    value={this.state.values.memberIds}
                    label="Team Members"
                    showErrors={this.state.showErrors}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("memberIds", value, valid)}
                    options={this.props.adminUsers.map(adminUser => ({
                        key: adminUser.id,
                        value: adminUser.id,
                        text: getUserDisplayNameAndTeam(adminUser, this.props.teams),
                        disabled: this.props.usersInOtherTeams.includes(adminUser.id)
                    }))}
                    search
                />
            </Form>
        );
    }

    public submit(): void {
        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

function mapStateToProps(state: AppState) {
    const team = teamSelector(state);
    return {
        model: {
            ...team,
            leaderIds: team && team.leaders && team.leaders.map(l => l.id),
            memberIds: team && team.members && team.members.map(m => m.id),
            customerIds: team && team.customers && team.customers.map(c => c.id)
        } as TeamEditModel,
        adminUsers: state.adminUsers.sort((a, b) => getUserSortableName(a).localeCompare(getUserSortableName(b))),
        customers: state.customers.sort((a, b) => a.name.localeCompare(b.name)),
        open: state.router.pathname?.endsWith("/edit"),
        basePath: basePathSelector(state),
        usersInOtherTeams: state.teams.flatMap(t => t.members.map(member => member.id)),
        teams: state.teams
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (team: TeamEditModel, basePath: string) => dispatch(saveTeam(team, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath)),
        loadAdminUsersOptions: () => dispatch(loadAdminUsers()),
        loadCustomersOptions: () => dispatch(loadCustomers())
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): EditProps & DispatchProps {
    return {
        ...propsFromState,
        save: (team: TeamEditModel) => propsFromDispatch.dispatchSave(team, `${propsFromState.basePath}/${propsFromState.model.id}`),
        close: () => propsFromDispatch.dispatchClose(`${propsFromState.basePath}/${propsFromState.model.id}`),
        loadAdminUsersOptions: () => propsFromDispatch.loadAdminUsersOptions(),
        loadCustomersOptions: () => propsFromDispatch.loadCustomersOptions()
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditModal);
